import { render, staticRenderFns } from "./sorticon.vue?vue&type=template&id=ea62e9fe"
import script from "./sorticon.vue?vue&type=script&lang=js"
export * from "./sorticon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports